import emailjs from "emailjs-com";
import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Navbar from "./Navbar";
import { Box} from "@material-ui/core";


const useStyles = makeStyles((theme) => ({
    form: {
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      position: "absolute",
    },
    
    button: {
      marginTop: "1rem",
      color: "tomato",
      borderColor: "tomato",
    },
  }));

 


export default function ContactUs() {

    const classes = useStyles();

    function sendEmail(e) {
        e.preventDefault();
    emailjs.sendForm('ranaankitcse', 'template_1gxw5mc', e.target, 'user_58dDrDfqBkphQtxjojCTu')
        .then((result) => {
            alert("Thank You, I've Received Your Message!");
            console.log(result.text);
        }, (error) => {
            alert("Error Encountered Please Try After Some Time!");
            console.log(error.text);
        });
        e.target.reset()
    }

    return(
        <Box component="div">
            <Navbar />
            <div className="container">
            
            <form id='contact-form' className={classes.form} onSubmit={sendEmail}>
               
                
                    <div className="row pt-5 mx-auto">
                        <div className="col-8 form-group mx-auto">
                            <input type="text" className="form-control" placeholder="Name" name="name" required />
                        </div>
                        <div className="col-8 form-group pt-2 mx-auto">
                            <input type="email" className="form-control" placeholder="Email Address" name="email" required/>
                        </div>
                        <div className="col-8 form-group pt-2 mx-auto">
                            <input type="text" className="form-control" placeholder="Subject" name="subject" required/>
                        </div>
                        <div className="col-8 form-group pt-2 mx-auto">
                            <textarea className="form-control" id="" cols="30" rows="8" placeholder="Your message" name="message" required></textarea>
                        </div>
                        <div className="col-8 pt-3 mx-auto">
                            <input type="submit" className="btn btn-info" value="Contact Me"></input>
                        </div>
                    </div>
                </form>
            </div>
        </Box>
    )
}